import React, { useEffect, useMemo, useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import FullPageLoader from '@src/common/FullPageLoader';
import PaymentFilter from "./PaymentFilter"
import PaymentListTable from './PaymentListTable';
import { useDispatch } from 'react-redux';
import { KEY_PAYMENT_ACTIVE_TAB_MAP,MANAGER_LEVEL_IDS,MAX_LEAD_ASSIGN_COUNT,COUNTRY_CODE,APP_COUNTRY } from '../../src/config/constant';
import { getPaymentList } from '../../src/store/slices/payment';
import { getMasterConfig, getPartnerList } from '../../src/store/slices/common';
import { getRoleListing } from '../../src/store/slices/RoleUser';
import secureStorage from '../../src/config/encrypt';
import { toast } from "react-toastify";
import { useLanguage } from "../../src/context/LanguageContext";
import ConfirmPopUp from '../../src/common/ConfirmPopUp';
import LeadAssigneePopup from '../../src/lead/common/LeadAssignPopup';
import { bulkPaymentAssignee } from '@src/store/slices/reconciliation';
import * as HELPER from "@src/config/helper";
import ApplicationTypeChips, { getApplicationTypeMap, getFiltersWithApplicationType } from '@src/common/ApplicationTypeChips';

// const PaymentTypeList: OptionType[] = [
//     { value: 1, label: 'Check' },
//     { value: 2, label: 'Trasaction' },
// ]


const FINANCE_VIEW_ROLE = "FINANCE_TEAM";
const paymentViewChips = [
    { key: 'all', label: 'All Payments' },
    { key: 'my', label: 'My Payments' },
];

const PaymentList: React.FC = () => {
    const dispatch: any = useDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [paginationData, setPaginationData] = useState<any>({});
    const [paymentList, setPaymentList] = useState<any>([]);
    const [selectedFilters, setSelectedFilters] = useState<any>({});
    const [paymentTypeList, setPaymentTypeList] = useState<any>([]);
    const [reasonList, setReasonList] = useState<any>([]);
    const [masterConfig, setMasterConfig] = useState<any>({});
    const [insurerList, setInsurerList] = useState<any>([]);
    const [activeTab, setActiveTab] = useState<any>('all');
    const [assignUsers, setAssignedUsers] = useState<any>([]);
    const [selectedLeads, setSelectedLeads] = useState<any[]>([]);
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name || "");
    const loggedInUserId = authUserInfo?.user_data?.id;
    const showPaymentViewChips = roleName === FINANCE_VIEW_ROLE;
    const isPhApp = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH;
    const [selectedPaymentView, setSelectedPaymentView] = useState<string>('my');
    const [selectedPaymentApplicationType, setSelectedPaymentApplicationType] = useState<string>('b2c');
    const [isAllLeadsSelected, setIsAllLeadsSelected] = useState<boolean>(false);
    const [showConfirmation,setShowConfirmation] = useState<boolean>(false);
    const [showLeadAssignPopup,setShowLeadAssignPopup] = useState<boolean>(false);
    const [agentId,setAgentId] = useState<number>(0);
    const { translations } = useLanguage();
    const paymentApplicationTypeMap = useMemo(() => getApplicationTypeMap(masterConfig), [masterConfig]);

    useEffect(() => {
        getMasterConfigApi();
        getPaymentListing({activeTab: KEY_PAYMENT_ACTIVE_TAB_MAP['first']});
        getPartners();
        getAssignedUsers();
        // eslint-disable-next-line
    }, [])

    const getMasterConfigApi = () => {
        setLoading(true);
        dispatch(getMasterConfig()).then((res: any) => {
        if (res && res.status === 200) {
            if (res.data) {
                setMasterConfig(res.data);
                setPaymentTypeList(res.data['recon_payement_type']);
                let reason_master: any = res.data['reason_master'];
                const filteredReasons = reason_master
                    .filter((item: any) => item.page === 2)
                    .map((item: any) => ({ value: item.value, label: item.label }));
                setReasonList(filteredReasons);
            }
        }
        }).catch((err: Error) => {
        setLoading(false);
        })
    }

    //GET INSURANCE LIST API
    const getPaymentViewFilters = (filters: Record<string, any> = {}, paymentView = selectedPaymentView) => {
        const filtersWithView = { ...filters };

        if (!isPhApp || !showPaymentViewChips) {
            return filtersWithView;
        }

        if (paymentView === 'my' && loggedInUserId) {
            filtersWithView.assign_user_id = loggedInUserId;
        } else {
            delete filtersWithView.assign_user_id;
        }

        return filtersWithView;
    };

    const getPaymentViewChipCount = (chipKey: string) => {
        if (chipKey === 'all') {
            return paginationData?.final_total_payments ?? paginationData?.all ?? 0;
        }

        return paginationData?.my_payment_count ?? 0;
    };

    const getPaymentApplicationTypeFilters = (filters: Record<string, any> = {}, applicationType = selectedPaymentApplicationType) => {
        return getFiltersWithApplicationType(filters, applicationType, paymentApplicationTypeMap);
    };

    const getPaymentListing = (params: any,isCall=true, paymentView = selectedPaymentView, applicationType = selectedPaymentApplicationType) => {
        let filters = {
            page_number: params?.page_number ?? 1,
            activeTab,
            isPaginationApply: true,
            page: "finance",
            ...params,
        };
        filters = getPaymentViewFilters(filters, paymentView);
        filters = getPaymentApplicationTypeFilters(filters, applicationType);
        setLoading(true);
        dispatch(getPaymentList(filters)).then((res: any) => {
            setLoading(false)
            if (res && res.status === 200) {
                setPaginationData(res.pagination);
                setPaymentList([...res.data])
                if(isAllLeadsSelected && isCall){
                    const allSelected: any[] = res.data.map((lead: any) => ({
                        id: lead.id
                    }));
                    setSelectedLeads(allSelected);
                }else{
                    setSelectedLeads([]);
                }
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const getPartners = () => {
        dispatch(getPartnerList()).then((res: any) => {
          if (res && res.status === 200) {        
            if (res.data) {
            const data = Array.isArray(res?.data) ? res.data : [];
            const updatedList = data.map((item: any) => ({
                ...item,
                isDisabled: false
            }));
            setInsurerList(updatedList);
            }
          }
        }).catch((err: Error) => {
          setLoading(false);
        })
      }

    const activeTabHandler = (tab: any) => {
    if (!tab) return;

    const activeTab = KEY_PAYMENT_ACTIVE_TAB_MAP[tab];
        if (activeTab) {
            setActiveTab(activeTab);
            setSelectedLeads([]);
            getPaymentListing({ page_number: 1, activeTab, ...selectedFilters },false);
        }
    }

    const handlePaymentViewChange = (paymentView: string) => {
        if (selectedPaymentView === paymentView) return;
        setSelectedPaymentView(paymentView);
        setSelectedLeads([]);
        setIsAllLeadsSelected(false);
        getPaymentListing({ page_number: 1, activeTab, ...selectedFilters }, false, paymentView);
    }

    const handlePaymentApplicationTypeChange = (applicationType: string) => {
        if (selectedPaymentApplicationType === applicationType) return;
        setSelectedPaymentApplicationType(applicationType);
        setSelectedLeads([]);
        setIsAllLeadsSelected(false);
        getPaymentListing({ page_number: 1, activeTab, ...selectedFilters }, false, selectedPaymentView, applicationType);
    }

    const getAssignedUsers = () => {
        dispatch(getRoleListing.getAssignedUsers({is_finance:true})).then((res: any) => {
            if (res && res.status === 200) {
                setAssignedUsers(res.data.map((user: any) => { return { label: user.firstname+" "+user.lastname, value: user.id,role_id:user.role_id,role_slug:user.role_slug } }));
            }
        }).catch((err: any) => {
            setLoading(false);
    
        })
    }
    
    const updateBulkAssignee = () => {
        try{
            if(selectedLeads.length === 0){
                toast.error(translations.Insurance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
                return;
            }
            if(isAllLeadsSelected){
                if(+paginationData.total > MAX_LEAD_ASSIGN_COUNT){
                    toast.error(`${translations.Insurance?.['MAX_ASSIGN_PAYMENT_LIMIT'] || translations.commonMsg?.loading} ${MAX_LEAD_ASSIGN_COUNT}`);
                    return;
                }
            }
            setShowLeadAssignPopup(true);
        }catch (error) {
            console.error("Error In Update Assignee:", error);
        } finally {
            setLoading(false);
        }
    }

     const handleSubmit = async () => {
          try{
            let paylaod:any = {
              payment_type:'finance',
              assigned_user_id : +agentId,
              isAllLeadsSelected : isAllLeadsSelected,
              data_filter : getPaymentApplicationTypeFilters(getPaymentViewFilters(selectedFilters))
            };
            if(isAllLeadsSelected){
              paylaod.activeTab = activeTab;
            }else{
              paylaod.leads = selectedLeads
            }
            setLoading(true);
            const response:any = await bulkPaymentAssignee(paylaod);
            if (response?.status === 200) {
              setShowConfirmation(false)
              setSelectedLeads([]);
              setIsAllLeadsSelected(false);
              getPaymentListing({ page_number: 1, activeTab, ...selectedFilters },false);
            }
          }catch (error) {
              console.error("Error while updating EMI detail:", error);
          }finally {
            // setLoading(false);
          }
      }

    return (
        <>
            <FullPageLoader show={loading} />
            {showLeadAssignPopup && <LeadAssigneePopup from={"Finance"} showLeadAssignPopup={showLeadAssignPopup} setShowLeadAssignPopup={setShowLeadAssignPopup} assignUsers={assignUsers} setShowConfirmation={setShowConfirmation} setAgentId={setAgentId} userRoleLabel={'Finance team'}/>}
            {showConfirmation === false ? ("") : (
                <ConfirmPopUp
                    confirmNo={() => {
                        setShowConfirmation(false);
                        setShowLeadAssignPopup(false);
                        setSelectedLeads([]);
                    }}
                    confirmYes={handleSubmit}
                    message={`All the ${isAllLeadsSelected === false ? selectedLeads.length : ''} records will get updated. Do you wish to continue ?`}
                    isConfirmNotVisible={true} 
                    from={"Finance"}
                />
            )}
            <div className='lead-list-outer container-fluid main-outer'>
                <div className=''>
                    <div className="top-heading  top-heading-btn">
                        <h1>Payment Verification</h1>
                        {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
                            <div className='d-flex'>
                                <button className="btn-line btn-export" onClick={updateBulkAssignee}>
                                    Update Assignee
                                </button>
                            </div>
                        }
                        {/* <button className="btn-line btn-export">
                            <i className="ic-save_alt m-sm-r"></i>
                            Download Data
                        </button> */}
                    </div>
                    <div className='loan-filter-bg'>
                        <div className='top-filter-bg'>
                            {/* <PaymentFilter /> */}
                            <PaymentFilter insurerList={insurerList} submitHandler={(filterParams: any) => { getPaymentListing(filterParams) }} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} PaymentMethodList={paymentTypeList} config={masterConfig} assign_user_id={assignUsers}/>
                        </div>
                    </div>
                    <div className='lead-list-table-outer'>
                        <ApplicationTypeChips
                            selectedApplicationType={selectedPaymentApplicationType}
                            paginationData={paginationData}
                            onChange={handlePaymentApplicationTypeChange}
                        />
                        {isPhApp && showPaymentViewChips && (
                            <div className="lead-view-chip-outer">
                                <span className="lead-view-label">VIEW</span>
                                <div className="lead-view-chip-list">
                                    {paymentViewChips.map((chip) => (
                                        <button
                                            key={chip.key}
                                            type="button"
                                            className={`lead-view-chip ${selectedPaymentView === chip.key ? 'active' : ''}`}
                                            onClick={() => handlePaymentViewChange(chip.key)}
                                        >
                                            {chip.label}
                                            <span>{getPaymentViewChipCount(chip.key)}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">

                            <Nav variant="pills" className="flex-column nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                                <div className="tab-list">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">
                                            All <span>({(paginationData && paginationData['all']) || 0})</span></Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">
                                            Pending <span>({(paginationData && paginationData['pending']) || 0})</span></Nav.Link>
                                    </Nav.Item>
                
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">
                                            Verified <span>({(paginationData && paginationData['verified']) || 0})</span></Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="fourth">
                                            Rejected <span>({(paginationData && paginationData['rejected']) || 0})</span></Nav.Link>
                                    </Nav.Item>
                                </div>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    {/* <PaymentListTable /> */}
                                    <PaymentListTable paymentList = {paymentList} paginationData={paginationData} getPaymentListing={getPaymentListing} selectedFilters={selectedFilters} paymentTypeList={paymentTypeList} reasonList={reasonList} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>


                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    {/* <PaymentListTable /> */}
                                    <PaymentListTable paymentList = {paymentList} paginationData={paginationData} getPaymentListing={getPaymentListing} selectedFilters={selectedFilters} paymentTypeList={paymentTypeList} reasonList={reasonList} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>

                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    {/* <PaymentListTable /> */}
                                    <PaymentListTable paymentList = {paymentList} paginationData={paginationData} getPaymentListing={getPaymentListing} selectedFilters={selectedFilters} paymentTypeList={paymentTypeList} reasonList={reasonList} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>

                                </Tab.Pane>
                                <Tab.Pane eventKey="fourth">
                                    {/* <PaymentListTable /> */}
                                    <PaymentListTable paymentList = {paymentList} paginationData={paginationData} getPaymentListing={getPaymentListing} selectedFilters={selectedFilters} paymentTypeList={paymentTypeList} reasonList={reasonList} assignUsers={assignUsers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>

                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>

                    </div>
                </div>
            </div>
        </>
    )
}



export default PaymentList;